module.exports = __webpack_public_path__ + "img/bg_mvision@2x.6a545565.jpg";